"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakeTooltip = exports.userActivityHeader = exports.userActivityView = exports.singleDayStyle = exports.daysStyle = exports.monthYearStyle = exports.lastDaysStyle = void 0;

var _reactEmotion = require("react-emotion");

var lastDaysStyle = function lastDaysStyle(theme, mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", mode === 'dark' ? theme.color.dark.amethyst : theme.color.accent, ";font-size:", mode === 'dark' ? '14px' : '16px', ";margin-right:6px;")
  );
};

exports.lastDaysStyle = lastDaysStyle;

var monthYearStyle = function monthYearStyle(theme, mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", mode === 'dark' ? theme.color.dark.iron : theme.color.black3, ";font-size:", mode === 'dark' ? '14px' : '16px', ";")
  );
};

exports.monthYearStyle = monthYearStyle;

var daysStyle = function daysStyle(theme, mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", mode === 'dark' ? theme.color.dark.iron : theme.color.black3, ";font-size:16px;font-weight:600;padding:15px 0px 7px;width:14.28%;height:18px;", mode === 'dark' ? "\n    font-size: 10px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.6;\n    letter-spacing: normal;" : '')
  );
};

exports.daysStyle = daysStyle;

var singleDayStyle = function singleDayStyle(_ref) {
  var fake = _ref.fake,
      active = _ref.active,
      theme = _ref.theme,
      mode = _ref.mode;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(fake === 'true' && "\n    opacity: 0;\n  ", "\n  padding:7px 0;width:14.28%;text-align:center;position:relative;> div{position:absolute !important;width:20px;height:20px;top:0;left:-5px;}::after{display:block;content:'';width:8px;height:8px;border-radius:50%;", active === 'true' ? "\n      background: ".concat(mode === 'dark' ? theme.color.dark.amethyst : theme.color.accent, ";\n    ") : "\n      background: ".concat(mode === 'dark' ? theme.color.dark.earth : theme.color.grey2, ";\n    "), "}")
  );
};

exports.singleDayStyle = singleDayStyle;

var userActivityView = function userActivityView() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:column;width:394px;height:224px;padding:22px 60px 32px;box-sizing:border-box;")
  );
};

exports.userActivityView = userActivityView;

var userActivityHeader = function userActivityHeader() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:row;margin-bottom:10px;")
  );
};

exports.userActivityHeader = userActivityHeader;
var fakeTooltip =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;");
exports.fakeTooltip = fakeTooltip;